import "./IconArrow.scss"
import IconContainer, { IconContainerProps } from "./IconContainer";

interface IconArrowProps extends IconContainerProps {
    direction?: 'up' | 'down';
}

export default function IconArrow(props: IconArrowProps) {
    return <div
        className="icon-arrow"
        style={{ transform: props.direction === 'up' ? 'rotate(180deg)' : 'rotate(0deg)' }}>
        <IconContainer size={props.size}>
            keyboard_arrow_down
        </IconContainer>
    </div>
}
